import { useEffect, useMemo, useState } from "react";
import AppShell from "./components/AppShell.jsx";
import ToolTabs from "./components/ToolTabs.jsx";
import WhatsNewNotice from "./components/WhatsNewNotice.jsx";
import { getLevel, isToolAvailable, levels } from "./data/appCatalog.js";
import Home from "./features/Home.jsx";
import LevelHome from "./features/LevelHome.jsx";
import PronunciationPage from "./features/pronunciation/PronunciationPage.jsx";
import SummarizingPage from "./features/summarizing/SummarizingPage.jsx";
import VocabularyPage from "./features/vocabulary/VocabularyPage.jsx";
import WritingPage from "./features/writing/WritingPage.jsx";

function readHashRoute() {
  const raw = window.location.hash.replace(/^#\/?/, "");
  const [levelId, toolId] = raw.split("/").filter(Boolean);
  return { levelId, toolId };
}

function renderTool(toolId, level) {
  if (toolId === "vocabulary") return <VocabularyPage level={level} />;
  if (toolId === "pronunciation") return <PronunciationPage level={level} />;
  if (toolId === "writing") return <WritingPage level={level} />;
  if (toolId === "summarizing") return <SummarizingPage level={level} />;
  return null;
}

export default function App() {
  const [route, setRoute] = useState(readHashRoute);

  useEffect(() => {
    const onHashChange = () => setRoute(readHashRoute());
    window.addEventListener("hashchange", onHashChange);
    return () => window.removeEventListener("hashchange", onHashChange);
  }, []);

  useEffect(() => {
    window.requestAnimationFrame(() => {
      window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    });
  }, [route.levelId, route.toolId]);

  function navigate(path) {
    window.location.hash = path;
    setRoute(readHashRoute());
  }

  const knownLevel = levels.some((level) => level.id === route.levelId);
  const level = useMemo(() => getLevel(route.levelId), [route.levelId]);
  const toolIsAvailable = route.toolId && isToolAvailable(level, route.toolId);
  const trackedLevel = knownLevel ? level.id : "home";
  const trackedTool = toolIsAvailable ? route.toolId : "home";

  useEffect(() => {
    window.SielpaAnalytics?.trackPageView(trackedLevel, trackedTool);
  }, [trackedLevel, trackedTool]);

  if (!knownLevel) {
    return (
      <>
        <WhatsNewNotice />
        <Home navigate={navigate} />
      </>
    );
  }

  return (
    <>
      <WhatsNewNotice />
      <AppShell level={level} toolId={toolIsAvailable ? route.toolId : null} navigate={navigate}>
        <ToolTabs level={level} currentToolId={toolIsAvailable ? route.toolId : null} navigate={navigate} />
        {toolIsAvailable ? renderTool(route.toolId, level) : <LevelHome level={level} navigate={navigate} />}
      </AppShell>
    </>
  );
}
